import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../../styles/globals';
import { IThemeProvider } from '../../../../styles/theme';

export const RecommendationDetailsCont = styled.div`
  flex: 1;
  overflow: auto;
  ${({ theme }: IThemeProvider) => `
  transition: linear 0.5s;
  margin-bottom: 24px;
    
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${theme.colors.secondary[30]};
    border-radius: 4px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.secondary[70]};
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.secondary[100]};
  }
  `}
`;

export const Title = styled(LabelRegularBoldM)`
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 16px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[90]};
  `};
`;

export const Background = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mikro} 0 ${theme.layout.spacing.centy} 0;
    border-radius: ${theme.layout.spacing.mikro};
  `}
`;
